import { render, staticRenderFns } from "./NewSchedule.vue?vue&type=template&id=fff4317c&scoped=true&"
import script from "./NewSchedule.vue?vue&type=script&lang=js&"
export * from "./NewSchedule.vue?vue&type=script&lang=js&"
import style0 from "./NewSchedule.vue?vue&type=style&index=0&id=fff4317c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff4317c",
  null
  
)

export default component.exports